import type { PageSnapshot } from '@/artifact/types';

interface ArtifactPageTabsClassNames {
  root?: string;
  tab?: string;
  tabActive?: string;
  tabInactive?: string;
  delete?: string;
  liveTab?: string;
  liveDelete?: string;
}

interface ArtifactPageTabsProps {
  pages: PageSnapshot[];
  viewingPageIndex: number | null;
  liveComponentsSize: number;
  onSelectPage: (index: number | null) => void;
  onDeletePage: (index: number) => void;
  onDeleteLivePage?: () => void;
  classNames?: ArtifactPageTabsClassNames;
}

export const ArtifactPageTabs = (_props: ArtifactPageTabsProps) => {
  // Multiple pages are disabled for now — the underlying store/messages
  // still support them, but we hide the tab UI entirely.
  return null;
};
